import { render, staticRenderFns } from "./EtapaFinalizarAnuencia.vue?vue&type=template&id=72a290a6&scoped=true"
import script from "./EtapaFinalizarAnuencia.vue?vue&type=script&lang=js"
export * from "./EtapaFinalizarAnuencia.vue?vue&type=script&lang=js"
import style0 from "./EtapaFinalizarAnuencia.vue?vue&type=style&index=0&id=72a290a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a290a6",
  null
  
)

export default component.exports